import { useEffect } from "react";
import { useHistory } from "react-router-dom";

type Options = {
  enabled?: boolean;                  
  thresholdX?: number;                
  maxDeviationY?: number;             
  maxDurationMs?: number;             
  noSwipeSelector?: string;           
};

export function useSwipeNavigation({
  enabled = true,
  thresholdX = 60,
  maxDeviationY = 40,
  maxDurationMs = 500,
  noSwipeSelector = ".no-swipe, .swiper, .swiper-container, .slick-slider, .image-gallery, [data-no-swipe='true']",
}: Options = {}) {
  const history = useHistory();

  useEffect(() => {
    if (!enabled) return;

    let startX = 0;
    let startY = 0;
    let startT = 0;

    const onStart = (e: TouchEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && target.closest(noSwipeSelector)) return;
      const t = e.changedTouches[0];
      startX = t.clientX;
      startY = t.clientY;
      startT = Date.now();
    };

    const onEnd = (e: TouchEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && target.closest(noSwipeSelector)) return;

      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const dt = Date.now() - startT;

      if (Math.abs(dy) > maxDeviationY) return;
      if (dt > maxDurationMs) return;
      if (Math.abs(dx) < thresholdX) return;

      if (dx > 0) {
        if (history.length > 1) history.goBack();
      } else {
        history.go(1);
      }
    };

    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });

    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchend", onEnd);
    };
  }, [
    enabled,
    history,
    thresholdX,
    maxDeviationY,
    maxDurationMs,
    noSwipeSelector,
  ]);
}
